'use strict';

var angular = require('angular');
var MappedInversionModalDirective = function MappedInversionModalDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/mapped-inversion-modal.html'),
    link: function link($scope, element) {
      $scope.$watch('showMappedWarningModal', function (newVal) {
        if (newVal) {
          angular.element('#mapped-fares-inversion-modal').modal('show');
        } else {
          element.parent('.modal:first').modal('hide');
        }
      });
    }
  };
};
MappedInversionModalDirective.$inject = [];
module.exports = MappedInversionModalDirective;